/** Normalize project/context tag ids before save (lowercase, strip @). */
export const normalizeTagId = (tag) =>
  String(tag ?? '')
    .replace(/^@/, '')
    .trim()
    .toLowerCase();

/**
 * @param {import('@/types').Task | Partial<import('@/types').Task>} task
 */
export const normalizeTaskTags = (task) => ({
  ...task,
  projects: (task.projects || []).map(normalizeTagId).filter(Boolean),
  contexts: (task.contexts || []).map(normalizeTagId).filter(Boolean),
});
